import { BasePolicy } from '../base-policy'
import { Org } from 'store/modules/orgs'

export class OrgPolicy extends BasePolicy<Org> {
  public get edit() {
    return this.user.isAdminOfOrg(this.object.id)
  }
}
